module.exports = __webpack_public_path__ + "img/bg_poster1.efdb0d21.png";